import { Orientation, type SerializedDockview } from 'dockview';
import { BRANCH, LEAF } from '../../../Layout/tokens';

export const EXECUTION_AND_PRICING_LAYOUT: SerializedDockview = {
  grid: {
    root: {
      data: [
        {
          data: {
            id: 'customerSecurityMaster',
            views: ['customerSymbolGroups', 'customerSecurityMaster'],
            activeView: 'customerSymbolGroups',
          },
          size: 481,
          type: LEAF,
        },
        {
          data: {
            id: 'pricingTiers',
            views: ['customerFeeTiers', 'customerAllInTiers'],
            activeView: 'customerAllInTiers',
          },
          size: 338,
          type: LEAF,
        },
        {
          data: {
            id: 'customerPricingRules',
            views: ['customerPricingRules'],
            activeView: 'customerPricingRules',
          },
          size: 341,
          type: LEAF,
        },
      ],
      size: 1661,
      type: BRANCH,
    },
    width: 1661,
    height: 1169,
    orientation: Orientation.VERTICAL,
  },
  panels: {
    customerSecurityMaster: {
      id: 'customerSecurityMaster',
      title: 'Security Master',
      contentComponent: 'customerSecurityMaster',
      params: { type: 'customerSecurityMaster', tabs: undefined },
    },
    customerSymbolGroups: {
      id: 'customerSymbolGroups',
      title: 'Symbol Groups',
      contentComponent: 'customerSymbolGroups',
      params: { type: 'customerSymbolGroups', tabs: undefined },
    },
    customerAllInTiers: {
      id: 'customerAllInTiers',
      title: 'Base Tiers',
      contentComponent: 'customerAllInTiers',
      params: { type: 'customerAllInTiers', tabs: undefined },
    },
    customerFeeTiers: {
      id: 'customerFeeTiers',
      title: 'Fee Tiers',
      contentComponent: 'customerFeeTiers',
      params: { type: 'customerFeeTiers', tabs: undefined },
    },
    customerPricingRules: {
      id: 'customerPricingRules',
      title: 'Pricing Rules',
      contentComponent: 'customerPricingRules',
      params: { type: 'customerPricingRules', tabs: undefined },
    },
  },
  activeGroup: 'customerSecurityMaster',
};
